import { render, staticRenderFns } from "./GeneralSkuTab.vue?vue&type=template&id=1e88c1de&scoped=true"
import script from "./GeneralSkuTab.vue?vue&type=script&lang=js"
export * from "./GeneralSkuTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralSkuTab.vue?vue&type=style&index=0&id=1e88c1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e88c1de",
  null
  
)

export default component.exports